import { Injectable } from "@angular/core";
import { Service } from "src/app/core/jsonapi/service";
import { WorkerEndReason } from "../_types/worker-end-reason";

@Injectable({
    providedIn: 'root',
})
export class WorkersEndReasonsService extends Service<WorkerEndReason> {
    public override type = 'workerEndReasons';
    public override url = 'providers/workerEndReasons';
}
